import { render, staticRenderFns } from "./heatmap_report_help.vue?vue&type=template&id=1c5af16a&scoped=true&lang=pug&"
import script from "./heatmap_report_help.vue?vue&type=script&lang=js&"
export * from "./heatmap_report_help.vue?vue&type=script&lang=js&"
import style0 from "./heatmap_report_help.vue?vue&type=style&index=0&id=1c5af16a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5af16a",
  null
  
)

export default component.exports